import React, { useEffect, useRef, useState } from 'react';

import { yaml } from '@codemirror/lang-yaml';
import { lintGutter } from '@codemirror/lint';
import CodeMirror from '@uiw/react-codemirror';
import useResizeObserver from '../../features/visual-analytics/hooks/resize-observer';
import { yamlLinter, codeMirrorErrorTheme } from './YamlEditorLinter';

export interface TpYamlEditoreProps {
  initialContent: string;
  contentModified?: (newContent: string) => void;
}

function YamlEditor({ initialContent, contentModified }: TpYamlEditoreProps) {
  const [value, setValue] = useState(initialContent);
  const [clientHeight, setClientHeight] = useState(200);
  const onChange = React.useCallback((val: string, viewUpdate: any) => {
    setValue(val);
    if (contentModified) contentModified(val);
  }, []);

  const refWrapper = useRef<HTMLDivElement>(null);

  useResizeObserver(refWrapper, (info: any) => {
    if (!refWrapper.current) return;
    const style = getComputedStyle(refWrapper.current);
    setClientHeight(refWrapper.current.clientHeight);
  });

  useEffect(() => {
    setValue(initialContent);
  }, [initialContent]);

  return (
    <div style={{ height: '100%' }} ref={refWrapper}>
      <CodeMirror
        value={value}
        height={`${clientHeight}px`}
        width="100%"
        extensions={[yaml(), lintGutter(), yamlLinter, codeMirrorErrorTheme]}
        onChange={onChange}
        theme={'dark'}
        editable={true}
        style={{ overflow: 'hidden' }} // overflow makes this an ancestor with scrolling, which is needed for sticky children.
      />
    </div>
  );
}

export default YamlEditor;
